import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@swyftx/aviary/atoms/Button';
import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Body, Heading } from '@swyftx/aviary/atoms/Typography';
import { Maintenance } from '@swyftx/aviary/icons/outlined';

import { Links } from '@shared/constants';

import { useCurrentPlatform } from 'src/lib/utils/hooks/useCurrentPlatform';

import { useLayoutStore } from '../hooks';

const SwyftxMarginAppShellMaintenance: React.FC = () => {
  const { t } = useTranslation('margin');
  const { setCurrentPlatform } = useCurrentPlatform();
  const { setSwitchPlatform, setMobileMenuOpen } = useLayoutStore();

  const onSwitchPlatform = useCallback(() => {
    setCurrentPlatform('swyftx');
    setSwitchPlatform('swyftx');
    setMobileMenuOpen(false);
  }, [setCurrentPlatform, setMobileMenuOpen, setSwitchPlatform]);

  return (
    <FlexLayout direction='column' className='h-full w-full' alignItems='center' justifyContent='center' spacing={12}>
      <Maintenance />
      <Heading size='h2' weight='light'>
        {t('maintenance.maintenancePage.title')}
      </Heading>
      <Body color='secondary' className='max-w-[500px] text-center'>
        {t('maintenance.maintenancePage.content')}
      </Body>
      <FlexLayout alignItems='center' justifyContent='center' className='mt-32' spacing={12}>
        <a href={Links.meta.status} target='_blank' rel='noreferrer'>
          <Button size='lg' variant='filled'>
            {t('maintenance.buttons.viewStatus')}
          </Button>
        </a>
        <Button size='lg' variant='outlined' onClick={onSwitchPlatform}>
          {t('maintenance.buttons.backToSpot')}
        </Button>
      </FlexLayout>
    </FlexLayout>
  );
};

export { SwyftxMarginAppShellMaintenance };
